import Vue from 'vue'
import * as types from '@/store/mutation-types'
import {hasUndefinedKey} from '@/utils/objectUtils';


export default {
    [types.SET_ACTIVE_SCENARIO]: (state, activeScenario) => {
        Vue.set(state, 'activeScenario', activeScenario);
    },

    [types.SET_ACTIVE_SCENARIO_DATA]: (state, activeScenarioData) => {
        Vue.set(state, 'activeScenarioData', activeScenarioData);
    },

    [types.SET_SCENARIO_INDICATORS]: (state, scenarioIndicators) => {
        Vue.set(state, 'scenarioIndicators', scenarioIndicators);
    },

    [types.SET_SCENARIO_ACTIVE_CHILD]: (state, scenarioActiveChild) => {
        Vue.set(state, 'scenarioActiveChild', scenarioActiveChild);
    },

    [types.SET_SCENARIO_ACTIVE_ADULT]: (state, scenarioActiveAdult) => {
        Vue.set(state, 'scenarioActiveAdult', scenarioActiveAdult);
    }
}
